import React, { FC, ReactNode } from "react";
import { Box } from "@UI/Components/Box/Box";

export interface OptionCardProps {
  children: ReactNode;
  isSelected?: boolean;
  isDisabled?: boolean;
  badge?: ReactNode;
}

/**
 * Shared bordered-card shell used by SingleSelectQuestion and MultiSelectQuestion.
 * Renders the Radio/Checkbox control passed as children. The control itself — not this
 * wrapper — must own the padding and `width`/`height: 100%` (see getOptionControlProps),
 * since the control's own <label> is the only element that's actually clickable; padding
 * put on this wrapper instead would sit outside that label and swallow clicks silently.
 */
export const OptionCard: FC<OptionCardProps> = ({
  children,
  isSelected = false,
  isDisabled = false,
  badge,
}) => (
  <Box position="relative" height="100%">
    <Box
      borderRadius="10px"
      borderWidth={isSelected ? "2px" : "1px"}
      borderStyle="solid"
      borderColor={isSelected ? "seaGreen.500" : "gray.400"}
      bg="white"
      height="100%"
      opacity={isDisabled ? 0.5 : 1}
      transition="border-color 0.15s"
      _hover={
        !isDisabled
          ? { borderColor: isSelected ? "seaGreen.500" : "gray.500" }
          : undefined
      }
    >
      {children}
    </Box>
    {badge && (
      <Box position="absolute" top="-10px" left="16px" zIndex={1}>
        {badge}
      </Box>
    )}
  </Box>
);
